import type { Entity } from '@/types/Entity';

export const EXCLUDE_PNP_TYPE_KEEP_NULL = {
  or: '(type.is.null,type.neq.pnp)',
} as const;

export const EXCLUDE_PNP_CATALOG_TYPE_KEEP_NULL = {
  or: '(catalog_type.is.null,catalog_type.neq.pnp)',
} as const;

/** Returns true if the entity is a catalog with type 'pnp'. */
export function isPnpCatalogEntity(entity: Pick<Entity, 'entity_data'>): boolean {
  const type = entity.entity_data?.type;
  return typeof type === 'string' && type.toLowerCase() === 'pnp';
}
